import React, { useCallback, useMemo } from "react";
import { ResourceInsightsDrawer } from "../../../components/resourceInsights";
import { dayToIso } from "../engine/dayMath";
import { usePlannerEngine, useSummaryRange, useUi, useView } from "../plannerContext";

/**
 * Resource Insights opened from the planner's resource rows. It is about the period the planner summarises, which the
 * user changes in the left panel, so it carries no period control of its own; it is limited to the planner's project
 * filter, follows the hours toggle, and a task pressed in it moves the planner to that task or opens it for editing.
 */
export default function PlannerResourceInsights() {
  const { actions } = usePlannerEngine();
  const resource = useUi((state) => state.resourceInsights);
  const projectFilter = useUi((state) => state.projectFilter);
  const showHours = useView((state) => state.showHours);
  const { startDay, endDay } = useSummaryRange();

  const period = useMemo(() => ({ startDate: dayToIso(startDay), endDate: dayToIso(endDay) }), [startDay, endDay]);
  const handleNavigate = useCallback((task) => actions.goToDate(task.allocation?.startDate ?? task.startDate), [actions]);
  const handleEdit = useCallback((task) => actions.openEditTask(task.id), [actions]);

  return (
    <ResourceInsightsDrawer
      open={Boolean(resource)}
      resource={resource}
      period={period}
      projectFilter={projectFilter}
      showHours={showHours}
      onNavigateToTask={handleNavigate}
      onEditTask={handleEdit}
      onClose={actions.closeResourceInsights}
    />
  );
}
